import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Bundle = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Bundle" {...props}>
    <path d="M14 1C15.3059 1 16.4141 1.83532 16.8262 3H20C21.6569 3 23 4.34315 23 6V18C23 19.6569 21.6569 21 20 21H16.8262C16.4141 22.1647 15.3059 23 14 23H10C8.69415 23 7.58594 22.1647 7.17383 21H4C2.34315 21 1 19.6569 1 18V6C1 4.34315 2.34315 3 4 3H7.17383C7.58594 1.83532 8.69415 1 10 1H14ZM9 20C9 20.5523 9.44772 21 10 21H14C14.5523 21 15 20.5523 15 20V16H9V20ZM3 18C3 18.5523 3.44772 19 4 19H7V15H4C3.64888 15 3.31314 14.936 3 14.8252V18ZM21 14.8252C20.6869 14.936 20.3511 15 20 15H17V19H20C20.5523 19 21 18.5523 21 18V14.8252ZM10 3C9.44772 3 9 3.44772 9 4V14H15V4C15 3.44772 14.5523 3 14 3H10ZM4 5C3.44772 5 3 5.44772 3 6V12C3 12.5523 3.44772 13 4 13H7V5H4ZM17 13H20C20.5523 13 21 12.5523 21 12V6C21 5.44772 20.5523 5 20 5H17V13Z" fill="#000" />
  </StyledIcon>
));

Bundle.displayName = 'Bundle';

export { Bundle };
